import Image from "react-bootstrap/Image";
import { getInitials } from "../../utils/formatUtils";
import { useTranslation } from "react-i18next";

export const UserAvatar = ({ account, showName = false, size = 42 }) => {
  const { t } = useTranslation();
  if (!account) return null;

  const initials = getInitials(`${account?.firstname} ${account?.lastname}`);

  return (
    <div className="user-avatar d-flex align-items-center justify-content-center">
      <div className="icon bg-primary text-white d-flex align-items-center justify-content-center">
        {account?.avatar ? (
          <Image
            src={account?.avatar}
            alt={initials}
            fluid
            width={size}
            height={size}
            loading="lazy"
            decoding="async"
            fetchpriority="low"
            referrerPolicy="no-referrer"
          />
        ) : (
          getInitials(initials)
        )}
      </div>
      <div
        className={`user-info text-truncate ms-2 d-block ${
          !showName ? "d-lg-none " : "full-info"
        }`}
      >
        <div className="fw-semibold text-truncate mb-1">
          {`${account?.firstname} ${account?.lastname}`}
        </div>
        {account.plan === "pro" ? (
          <div className="d-flex">
            <div className="rounded bg-purple bg-opacity-10 d-flex align-items-center text-purple py-05 px-2 shadow-sm">
              <i className="bi bi-stars me-1 d-flex"></i>
              <span className="small fw-semibold">{t("subscription.pro")}</span>
            </div>
          </div>
        ) : (
          <div className="text-success fw-medium">
            <i className="bi bi-check-circle-fill me-1"></i>
            <span>{t("subscription.free")}</span>
          </div>
        )}
      </div>
    </div>
  );
};
